import { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import api from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = (location.hash.match(/session_id=([^&]+)/) || [])[1];
    if (!sid) {
      setError("Sign-in didn't complete — please try again.");
      return;
    }
    api.post("/auth/google/session", { session_id: sid }).then(({ data }) => {
      if (data.kind === "client" && data.portal_url) {
        window.location.replace(data.portal_url);
        return;
      }
      const u = data.user || {};
      const scopeHome = (u.scopes || []).includes("references") ? "/references" : (u.scopes || []).includes("careplans") ? "/clients" : "/dashboard";
      window.location.replace(u.role === "admin" ? "/dashboard" : scopeHome);
    }).catch((e) => {
      setError(e?.response?.data?.detail || "Sign-in didn't complete — please try again.");
    });
  }, []); /* eslint-disable-line react-hooks/exhaustive-deps */

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-sm text-center" data-testid="google-auth-error">
          <p className="font-heading text-xl font-medium text-[#23282f]">Couldn't sign you in</p>
          <p className="mt-2 text-sm leading-relaxed text-stone-600">{error}</p>
          <Link to="/login" className="mt-4 inline-block text-sm font-semibold text-[#6A3E97] hover:underline" data-testid="google-auth-back">Back to sign in</Link>
        </div>
      ) : (
        <p className="text-sm font-medium text-stone-500" data-testid="google-auth-processing">Signing you in…</p>
      )}
    </div>
  );
}
